import React, { useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import "./TechnologySection.css";
import { useTranslation } from "react-i18next";

export default function TechnologySection({ vehicle }) {
  const { t } = useTranslation();

  const techSlides = vehicle.technologySlides || [];
  const sliderRef = useRef(null);

  if (!techSlides.length) return null;

  const scrollByAmount = (direction) => {
    if (!sliderRef.current) return;
    const slider = sliderRef.current;
    const width = slider.getBoundingClientRect().width;

    slider.scrollBy({
      left: direction === "right" ? width : -width,
      behavior: "smooth",
    });
  };

  return (
    <section className="technology-section section-spacing">
      <Container fluid>
        <div className="text-center">
          <SectionTitle
            subtitle={t("vehicleTechnology.subtitle")}
            title={t("vehicleTechnology.title")}
          />

          <p className="brand-section-desc">{t("vehicleTechnology.tagline")}</p>
        </div>

        <div className="technology-section__slider-wrapper">
          <div className="technology-section__slider" ref={sliderRef}>
            {techSlides.map((slide) => {
              const slideTitle = slide.titleKey ? t(slide.titleKey) : slide.title || "";
              const p1 = slide.paragraph1Key
                ? t(slide.paragraph1Key)
                : slide.paragraph1 || "";
              const p2 = slide.paragraph2Key
                ? t(slide.paragraph2Key)
                : slide.paragraph2 || "";

              return (
                <div key={slide.id} className="technology-section__slide">
                  <Row className="align-items-center g-4">
                    {/* Left column: text */}
                    <Col xs={12} lg={6}>
                      <div className="technology-section__text">
                        <h3 className="technology-section__slide-title">
                          {slideTitle}
                        </h3>

                        {p1 && (
                          <p className="technology-section__paragraph">{p1}</p>
                        )}

                        {p2 && (
                          <p className="technology-section__paragraph">{p2}</p>
                        )}
                      </div>
                    </Col>

                    {/* Right column: image */}
                    <Col xs={12} lg={6}>
                      <div className="technology-section__image-wrapper">
                        {slide.imageSrc && (
                          <img
                            src={slide.imageSrc}
                            alt={slideTitle}
                            className="technology-section__image"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        </div>

        <div className="text-center">
          <div className="technology-section__controls">
            <button
              type="button"
              className="technology-section__arrow"
              onClick={() => scrollByAmount("left")}
              aria-label={t("vehicleTechnology.ariaPrev")}
            >
              ‹
            </button>

            <button
              type="button"
              className="technology-section__arrow"
              onClick={() => scrollByAmount("right")}
              aria-label={t("vehicleTechnology.ariaNext")}
            >
              ›
            </button>
          </div>
        </div>
      </Container>
    </section>
  );
}